(function () {
  if (window.__ariHeroVideoInit) return;
  window.__ariHeroVideoInit = true;

  var desktopQuery = window.matchMedia('(min-width: 768px)');

  function loadVideo(video) {
    if (!video || video.getAttribute('data-loaded') === 'true') return;
    var src = video.getAttribute('data-src');
    if (!src) return;
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.setAttribute('data-loaded', 'true');
    video.load();
  }

  function playVideo(video) {
    var tryPlay = function () {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    };
    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('canplay', tryPlay, { once: true });
    }
  }

  function posterImage(video) {
    var previous = video.previousElementSibling;
    if (!previous) return null;
    if (previous.tagName === 'IMG') return previous;
    if (previous.tagName === 'PICTURE') return previous.querySelector('img');
    return null;
  }

  function whenPosterReady(video, callback) {
    var img = posterImage(video);
    if (!img || (img.complete && img.naturalWidth > 0)) {
      callback();
      return;
    }

    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      callback();
    };

    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
  }

  function isActiveSlide(video) {
    var slide = video.closest('.slick-slide');
    if (!slide) return true;
    return slide.classList.contains('slick-active') || slide.classList.contains('slick-current');
  }

  function syncHeroVideos() {
    var videos = document.querySelectorAll('.js-hero-video');
    if (!desktopQuery.matches) {
      videos.forEach(function (video) {
        video.pause();
      });
      return;
    }

    videos.forEach(function (video) {
      var slider = video.closest('.custom-hero-banner-slider');
      if (slider && !slider.classList.contains('slick-initialized')) return;

      if (isActiveSlide(video) || video.getAttribute('data-hero-active') === 'true') {
        whenPosterReady(video, function () {
          loadVideo(video);
          playVideo(video);
        });
      } else if (video.getAttribute('data-loaded') === 'true') {
        video.pause();
      }
    });
  }

  function bindSlider(slider) {
    if (!slider || slider.getAttribute('data-hero-video-bound') === 'true') return;
    slider.setAttribute('data-hero-video-bound', 'true');
    if (!window.jQuery) return;
    window.jQuery(slider).on('init afterChange', syncHeroVideos);
  }

  function init() {
    document.querySelectorAll('.custom-hero-banner-slider').forEach(bindSlider);
    syncHeroVideos();
  }

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', syncHeroVideos);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(syncHeroVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
